import React from "react";

const ShowcaseCard = ({ item = {}, onClick }) => {
  //   clinicianImage="path_to_image.jpg"
  //   topicName="Inflammatory Joint Flare Follow-Up"
  //   tags={['Orthopedics', 'Post-Op']}
  //   publisher="Isabel Hartig, MSN, APRN"
  //   publisherImage="path_to_publisher_image.jpg"
  //   additionalInfo={['Specialty: Rheumatology', 'Subspecialty: Cardiovascular ICU']}

  return (
    <div className="card-glass" onClick={onClick}>
      {/* Clinician Image */}
      <img
        src={item.clinicianImage}
        alt={`${item.name}'s profile`}
        className="w-full h-40 rounded-t-lg object-cover"
      />

      {/* Name */}
      <div className="mt-2">
        <h2 className="text-white text-lg font-semibold">{item.name}</h2>
      </div>

      {/* Topic Name */}
      <div className="mt-1">
        <h3 className="text-md text-blue-500">{item.name}</h3>
      </div>

      {/* Tags */}
      <div className="mt-4 flex justify-start flex-wrap min-h-[36px]">
        {item?.tags?.map((tag, index) => (
          <span
            key={index}
            className="bg-blue-600 text-white text-xs px-2 py-1 rounded-full mr-2 mb-2 h-6"
          >
            {tag}
          </span>
        ))}
      </div>

      {/* Publisher Information */}
      <div className="mt-4 flex items-center border-t border-gray-500 pt-2">
        <img
          src={item?.publisherImage || "/logo128.svg"}
          alt={`${item?.publisher} profile`}
          className="w-10 h-10 rounded-full mr-2"
        />
        <div>
          <h4 className="text-gray-400 text-sm font-medium">
            {item?.publisher || "Lumeris"}
          </h4>
          {(item?.additionalInfo || ["Corporate Publisher"]).map(
            (info, index) => (
              <p key={index} className="text-xs text-gray-500">
                {info}
              </p>
            )
          )}
        </div>
      </div>
    </div>
  );
};

export default ShowcaseCard;
